import {
  ABOUT_ME_SECTION_ID,
  COMPACT_LIST_GALLERY,
  COMPACT_MASONRY_GALLERY,
  DEALS_SECTION_ID,
  DESCRIPTION_SECTION_ID,
  FAQ_AWARDS_PREFERRED_SUPPLIERS_SECTION_ID,
  FEATURES_SECTION_ID,
  LOCATION_SECTION_ID,
  MANAGER_MESSAGE_SECTION_ID,
  PHOTO_SECTION_ID,
  PRICING_SECTION_ID,
  REAL_WEDDINGS_SECTION_ID,
  REVIEWS_SECTION_ID,
  VIEW_PROFILE_SECTION_ID,
  VISIT_VENUE_SECTION_ID,
  PLAN_A_VISIT_SECTION_ID,
  PLAN_A_VISIT_SECTION_ID_MOCK,
  WEDDING_FAIRS_SECTION_ID,
} from '@bridebook/web/app-shared/components/supplier/sections/ids';
import { GallerySlideType } from '@bridebook/web/lib/supplier-gallery/types';

export const ANALYTICS_BY_SECTION_ID = {
  [DEALS_SECTION_ID]: 'Deals',
  [ABOUT_ME_SECTION_ID]: 'About',
  [PRICING_SECTION_ID]: 'Pricing',
  [FEATURES_SECTION_ID]: 'Overview',
  [DESCRIPTION_SECTION_ID]: 'Description',
  [REAL_WEDDINGS_SECTION_ID]: 'Real Weddings',
  [REVIEWS_SECTION_ID]: 'Reviews',
  [LOCATION_SECTION_ID]: 'Location',
  [FAQ_AWARDS_PREFERRED_SUPPLIERS_SECTION_ID]: 'FAQs, Awards and Preferred Suppliers',
  [COMPACT_MASONRY_GALLERY]: 'masonryGallery',
  [COMPACT_LIST_GALLERY]: 'listGallery',
  [PHOTO_SECTION_ID]: 'photo',
  [MANAGER_MESSAGE_SECTION_ID]: 'managersMessage',
  [VIEW_PROFILE_SECTION_ID]: 'viewProfile',
  [VISIT_VENUE_SECTION_ID]: 'visitVenue',
  [PLAN_A_VISIT_SECTION_ID]: 'planAVisit',
  [PLAN_A_VISIT_SECTION_ID_MOCK]: 'planAVisitMock',
  [WEDDING_FAIRS_SECTION_ID]: 'weddingFairsCarousel',
} as const;

// supplier gallery slides to analytics type
export const GallerySlideTypeToAnalytics = {
  [GallerySlideType.MainPhoto]: ANALYTICS_BY_SECTION_ID[PHOTO_SECTION_ID],
  [GallerySlideType.Photo]: ANALYTICS_BY_SECTION_ID[PHOTO_SECTION_ID],
  [GallerySlideType.Description]: ANALYTICS_BY_SECTION_ID[DESCRIPTION_SECTION_ID],
  [GallerySlideType.ManagerMessage]: ANALYTICS_BY_SECTION_ID[MANAGER_MESSAGE_SECTION_ID],
  [GallerySlideType.RealWedding]: ANALYTICS_BY_SECTION_ID[REAL_WEDDINGS_SECTION_ID],
  [GallerySlideType.Review]: ANALYTICS_BY_SECTION_ID[REVIEWS_SECTION_ID],
  [GallerySlideType.ViewProfile]: ANALYTICS_BY_SECTION_ID[VIEW_PROFILE_SECTION_ID],
};
